export default "/images/vendor/geoportal-extensions-openlayers/src/OpenLayers/CSS/Controls/Editor/GPEditorLayerTools.png?43ca5b24e342ca25970d6f4d46cd815d";